const router = [
  {
    path: '/manager',
    name: 'managerManagement',
    redirect: '/manager/management',
    component: () => import('@/modules/ManagerManagement/pages'),
    children: [
      {
        path: 'management',
        name: 'managerManagement',
        component: () => import('@/modules/ManagerManagement/pages/Management'),
        meta: {
          requiresAuth: true,
          requiresPermission: false
        }
      }
    ],
    meta: {
      requiresAuth: true,
      requiresPermission: false
    }
  }
]
export default router
